"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[48],{

/***/ 40048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ GoogleAnalytics; }
/* harmony export */ });
/* harmony import */ var react_ga__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50542);
/* harmony import */ var _helpers_misc_isScrapping__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31394);
/* harmony import */ var _helpers_track_trackPageView__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14726);
/* harmony import */ var _hooks_useCookiesAccepted__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35756);
/* harmony import */ var _hooks_useEffect__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10338);
/* harmony import */ var ga_4_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13241);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);







function GoogleAnalytics(props) {
    var config = props.integrations;
    var cookies = (0,_hooks_useCookiesAccepted__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var getCode = function() {
        if (_helpers_misc_isScrapping__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z) return;
        if (!config) return;
        if (!config.integrations) return;
        if (!config.integrations.googleAnalyticsId) return;
        return config.integrations.googleAnalyticsId;
    };
    var getCodeV4 = function() {
        if (_helpers_misc_isScrapping__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z) return;
        if (!config) return;
        if (!config.integrations) return;
        if (!config.integrations.googleAnalyticsV4Id) return;
        return config.integrations.googleAnalyticsV4Id;
    };
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    (0,_hooks_useEffect__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
        var code = getCode();
        var codeV4 = getCodeV4();
        if (!code && !codeV4 || !cookies) return;
        if (code) {
            react_ga__WEBPACK_IMPORTED_MODULE_0__/* ["default"].initialize */ .ZP.initialize(code);
            react_ga__WEBPACK_IMPORTED_MODULE_0__/* ["default"].plugin.require */ .ZP.plugin.require("ec");
        }
        if (!code && codeV4) {
            var ga4react = new ga_4_react__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP(codeV4);
            ga4react.initialize().then(function(ga4) {
                ga4.pageview(router.asPath);
            }, function(err) {
                console.error(err);
            });
        }
        (0,_helpers_track_trackPageView__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(router.asPath);
    }, [
        cookies
    ]);
    return null;
};


/***/ }),

/***/ 14726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ trackPageView; }
/* harmony export */ });
/* harmony import */ var react_ga__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50542);
/* harmony import */ var ga_4_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13241);
/* harmony import */ var _helpers_getReactPixel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55985);



function trackPageView(pathname) {
    var pixel = (0,_helpers_getReactPixel__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    if (!pathname.includes("/virtual")) {
        pixel === null || pixel === void 0 ? void 0 : pixel.pageView();
    }
    react_ga__WEBPACK_IMPORTED_MODULE_0__/* ["default"].pageview */ .ZP.pageview(pathname);
    if (ga_4_react__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isInitialized */ .ZP.isInitialized()) {
        var ga4 = ga_4_react__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getGA4React */ .ZP.getGA4React();
        if (ga4) {
            ga4.pageview(pathname);
        }
    }
};


/***/ })

}]);